// ===============================  受眾選擇  ===============================

export enum Gender {
  ALL = 'all',
  MALE = 'male',
  FEMALE = 'female',
}
